import { render, staticRenderFns } from "./mySite.vue?vue&type=template&id=d977d15e&scoped=true&"
import script from "./mySite.vue?vue&type=script&lang=js&"
export * from "./mySite.vue?vue&type=script&lang=js&"
import style0 from "./mySite.vue?vue&type=style&index=0&id=d977d15e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d977d15e",
  null
  
)

export default component.exports